import React, { useContext, useState } from "react";
import { PopupWrapper } from "../../../../components/styled/BasicBlocks";
import { SideMenuCommonHeader } from "./SideMenuCommon";
import "./SideMenuLanguage.css";
import { AppContext } from "../../../../appContext";
import { ISideMenuRouteProps } from "./ISideMenuRouteProps";


export const SideMenuLanguage = ({onClose}: ISideMenuRouteProps) => {
    const {translate, currentLanguage, setCurrentLanguage} = useContext(AppContext);
    //const [selectedLanguage, setSelectedLanguage] = useState('English');

    const handleSave = ()=>{

    }

    const handleClose = ()=>{
        onClose();
    }

    const languageList = {
        en: 'English', 
        ru: 'Русский',
        ua: 'Українська'
    };

    return <PopupWrapper className="SideMenuLanguage">
        <SideMenuCommonHeader text={translate('sideMenu_language')} onClose={handleClose}></SideMenuCommonHeader>
        <div className="SideMenuLanguage_select">
            {Object.keys(languageList).map(language=>{
                return <div className={`button calendarGrid_modeMenu_item ${language == currentLanguage ? 'calendarGrid_modeMenu_item--active' : ''}`}
                    onClick={()=>{
                        localStorage.setItem('language', language);
                        setCurrentLanguage(language);
                    }}
                >
                    {languageList[language as keyof typeof languageList]}
                </div>
            })}
        </div>
    </PopupWrapper>
}